import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import TokenTestDisplay from '../components/TokenTestDisplay'; 

const DashboardPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="p-4">
       <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
            <div className="flex justify-between items-center mb-4">
                <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>
                <button 
                    onClick={handleLogout}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                >
                    Logout
                </button>
            </div>
            {user && (
                <div>
                    <p className="text-gray-600"><span className="font-semibold">Welcome,</span> {user.username}</p>
                    <p className="text-gray-600"><span className="font-semibold">User ID:</span> {user.userId}</p>
                    <p className="text-gray-600 capitalize"><span className="font-semibold">Role:</span> {user.role}</p>
                </div>
            )}
            <TokenTestDisplay /> 
       </div>
    </div>
  );
};

export default DashboardPage;
